// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingAddressStyles } from "@tps/Overrides/Widgets/CheckoutShipping/ShippingAddress";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { getSharedAddressInfoDisplayStyles, modalButtonsActionStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

shippingAddressStyles.container = { gap: 0 };
shippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
shippingAddressStyles.headingText = {
    variant: "h6",
    css: css`
        margin-bottom: 12px;
    `,
};
shippingAddressStyles.shippingAddressWarningText = {
    ...fontConfig.xSmall,
    css: css`
        margin-bottom: 12px;
    `,
};
shippingAddressStyles.multipleShippingAddressMessage = {
    ...fontConfig.xSmall,
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 12px;
    `,
};
shippingAddressStyles.selectSavedAddressLink = {
    css: css`
        margin-top: 8px;
    `,
};
shippingAddressStyles.addressBookModal = { sizeVariant: "medium" };
shippingAddressStyles.addressBookModalButtonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 1rem;
    `,
};
shippingAddressStyles.addressBookModalCancelButton = { variant: "secondary" };
shippingAddressStyles.oneTimeAddressGridItem = { width: 12 };
shippingAddressStyles.addressDisplayAndFormGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
shippingAddressStyles.addressDisplay = {
    ...getSharedAddressInfoDisplayStyles("small"),
};
shippingAddressStyles.useBillingAddressButton = {
    variant: "secondary",
    css: css`
        margin-top: 20px;
    `,
};
shippingAddressStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        margin-top: 24px;
    `,
};
shippingAddressStyles.oneTimeAddressModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            ${xScreen("lte", "md")} {
                margin: 15px 140px;
                min-width: 325px;
            }
        `,
    },
};
shippingAddressStyles.oneTimeShippingAddress = {
    formFields: {
        firstNameGridItem: { width: [12, 12, 12, 12, 6] },
        lastNameGridItem: { width: [12, 12, 12, 12, 6] },
        companyNameGridItem: { width: 12 },
        postalCodeGridItem: { width: 12 },
        stateGridItem: { width: 12 },
        attentionGridItem: { width: 12 },
    },
};
shippingAddressStyles.addressOptionRadio = {
    css: css`
        display: flex;
        label {
            flex-wrap: wrap;
        }
    `,
};
shippingAddressStyles.addressLinkWrapper = {
    css: css`
        width: 100%;
        margin: 8px 0 0 21px;
    `,
};
shippingAddressStyles.editAddressLink = {
    css: css`
        margin-top: 8px;
    `,
};
